import { Months } from '~/components/Notification';

export const getFormattedDate = (date: string): string => {
  const dateArr = date.split('-');

  return dateArr.length >= 3 ? `${parseInt(dateArr[2], 10)} ${Months[Number(dateArr[1])]} ${dateArr[0]}` : '';
};
